import { ErrorViewPlaceholder } from "../../Template"  
import './editor_template.css'


export const EditorBtn = ({action, text}) => <button className="editor" onClick={action}>{text}</button>

export const EditorSection = ({children}) => <section className="editor">{children}</section>

export const CenterContainer = ({children}) => <div className="center-container">{children}</div>

export const AuthBtn = ({ auth_action, text }) =>  {
    return (
        <div className="auth-btn">
            <button onClick={auth_action} className="auth-btn">{text}</button>
        </div>  
    )
}

export const EditorErrorView = ({err_msg, err_details}) => {
    return (<EditorSection> 
                <ErrorViewPlaceholder title={`ERROR: ${err_msg}`} details={err_details}/>
        </EditorSection>)
}
